import React from 'react'
import './footer.css'
import { Link } from 'react-router-dom'
import logo from './lg2.png';

 const Footer =()=> {
  return (
    <>
      <section className="footer__section">
      <div className="footer__width">
      <div className="row">

        <div className='footer_col' >
        <img src={logo}  alt="logo"></img>

          <p>Everyday tools, elevated for your modern life. </p>
        </div>
        <div className='footer_col' >
 <p>© 2025 Lavouch. All rights reserved. </p>
        </div>
 
 
        </div>
        </div>

      </section> 
    </>
  )
}
export default Footer;